import { useEffect, useState } from "react";
import Navbar from "@/components/marketing/Navbar";
import Footer from "@/components/marketing/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Mail } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", company: "", message: "" });
  const [sending, setSending] = useState(false);
  useEffect(() => { document.title = "Contact | NetLift"; }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message || "Message sent.");
      setForm({ name: "", email: "", company: "", message: "" });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="mx-auto max-w-3xl px-5 py-20 sm:px-8">
        <h1 className="font-heading text-4xl font-semibold tracking-tight text-slate-900">Contact</h1>
        <p className="mt-3 text-base text-slate-600">
          Questions about NetLift? Send a note and we&apos;ll reply at{" "}
          <a href="mailto:support@netlift.app" className="font-medium text-navy underline">support@netlift.app</a>.
        </p>
        <form onSubmit={submit} className="mt-8 rounded-lg border border-slate-200 bg-white p-6 shadow-sm" data-testid="contact-form">
          <div className="grid gap-4 sm:grid-cols-2">
            <div>
              <Label htmlFor="name">Name</Label>
              <Input id="name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
            </div>
            <div>
              <Label htmlFor="email">Work email</Label>
              <Input id="email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" />
            </div>
          </div>
          <div className="mt-4">
            <Label htmlFor="company">Company</Label>
            <Input id="company" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} data-testid="contact-company" />
          </div>
          <div className="mt-4">
            <Label htmlFor="message">Message</Label>
            <Textarea id="message" rows={5} required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
          </div>
          <Button type="submit" disabled={sending} className="mt-5 bg-editorial hover:bg-editorial/90" data-testid="contact-submit">
            <Mail className="mr-2 h-4 w-4" /> {sending ? "Sending..." : "Send message"}
          </Button>
        </form>
      </section>
      <Footer />
    </div>
  );
}
